const openSiteLocationOnMap = (locationAddress: string) => {
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationAddress)}`;

  window.open(mapUrl, "_blank");
};

export { openSiteLocationOnMap };
